import React, { createContext, useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import { getCategories, createCategory, updateCategory, deleteCategory } from '../services/api';

export const BlogCategoryContext = createContext();

export const BlogCategoryProvider = ({ children }) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCategories = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getCategories();
      setCategories(response.data);
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'خطا در دریافت دسته‌بندی‌ها';
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  }, []);

  const addCategory = useCallback(async (categoryDto) => {
    setLoading(true);
    setError(null);
    try {
      const response = await createCategory(categoryDto);
      setCategories((prev) => [...prev, response.data]);
      toast.success('دسته‌بندی با موفقیت اضافه شد');
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'خطا در افزودن دسته‌بندی';
      setError(errorMessage);
      toast.error(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const editCategory = useCallback(async (id, categoryDto) => {
    setLoading(true);
    setError(null);
    try {
      const response = await updateCategory(id, categoryDto);
      setCategories((prev) => prev.map((cat) => (cat.id === id ? response.data : cat)));
      toast.success('دسته‌بندی با موفقیت به‌روزرسانی شد');
      return response.data;
    } catch (err) {
      const errorMessage =
        err.response?.status === 404
          ? 'دسته‌بندی مورد نظر یافت نشد'
          : err.response?.data?.message || 'خطا در به‌روزرسانی دسته‌بندی';
      setError(errorMessage);
      toast.error(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const removeCategory = useCallback(async (id) => {
    setLoading(true);
    setError(null);
    try {
      await deleteCategory(id);
      setCategories((prev) => prev.filter((cat) => cat.id !== id));
      toast.success('دسته‌بندی با موفقیت حذف شد');
    } catch (err) {
      const errorMessage =
        err.response?.status === 404
          ? 'دسته‌بندی مورد نظر یافت نشد'
          : err.response?.data?.message || 'خطا در حذف دسته‌بندی';
      setError(errorMessage);
      toast.error(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <BlogCategoryContext.Provider
      value={{
        categories,
        loading,
        error,
        fetchCategories,
        addCategory,
        editCategory,
        removeCategory,
      }}
    >
      {children}
    </BlogCategoryContext.Provider>
  );
};